import { uniqueId } from "@/views/zhiji/js/common/util.js";
import { ParamError } from "@/views/zhiji/js/common/errors.js";
import i18n from "@/i18n";

export default {
    widgetName: "MultilineText",
    serverType: "textarea",
    initContent() {
        return {
            uId: uniqueId(),
            updateState: "add",
            wtType: "MultilineText",
            title: "",
            tip: "",
            isNeed: false
        };
    },
    checkContent(content) {
        if (!content.title) {
            throw new ParamError(i18n.t("zhiji.form.multilineText.error.title"));
        } else if (!content.tip) {
            throw new ParamError(i18n.t("zhiji.form.multilineText.error.tip"));
        }
    },
    // 后台数据转前端数据
    server2Client(content) {
        return {
            uId: uniqueId(),
            num: content.num,
            wtType: "MultilineText",
            updateState: "",
            title: content.title,
            tip: content.tip,
            isNeed: content.is_need
        };
    },
    // 前端数据转后台数据
    client2Server(content) {
        return {
            num: 0,
            title: content.title,
            type: "textarea",
            name: "textarea",
            is_need: content.isNeed,
            tip: content.tip,
            value: "",
            verify: "",
            readonly: "false"
        };
    }
};
